import { Typography } from '@mui/material';
import { totalOpenJobsSelector } from 'pages/candidateOfferList/store';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

export default function OpenOffersCountDense() {
    const { t } = useTranslation('candidateOffers');
    const count = useSelector(totalOpenJobsSelector);

    return (
        <Typography variant="body1"
            fontWeight="medium" >
            { t('overview.openJobsCount', { count }) }
        </Typography>
    );
}
